module.exports = __webpack_public_path__ + "img/wandelende mensen.0aaa5896.jpg";